import ModalWithQuantity from './ModalWithQuantity';

export default ModalWithQuantity;
